import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'banks',
    method: 'get'
  })
}

export function fetchFiltered(queriesParams) {
  return request({
    url: `banks`,
    method: 'get',
    params: queriesParams
  })
}

export function addBank (bank) {
  return request({
    method: 'post',
    url: 'bank',
    data: bank
  })
}

export function show (id) {
  return request({
    url: `bank/${id}`,
    method: 'get'
  })
}

export function edit (id, data) {
  return request({
    url: `bank/${id}`,
    method: 'patch',
    data
  })
}
